import { normalizePreparedOperationResponse } from "../api/schemas";
import { safeOperationSnapshot } from "../store/protocolOperations";
import { reconcileOperationUntilTerminal } from "./operationReconciliation";

export const extractMetaKeepTransactionId = (consentResult) =>
  consentResult?.transactionId ?? null;

export const runMetaKeepOperation = async ({
  prepareResponse,
  sdk,
  operationClient,
  store = null,
  poll = false,
  maxPolls = 3,
  pollIntervalMs = 1000,
} = {}) => {
  const operation = normalizePreparedOperationResponse(prepareResponse);
  if (operation.executionMode !== "METAKEEP_BUSINESS_WALLET") {
    throw new Error("expected METAKEEP_BUSINESS_WALLET operation");
  }
  if (!sdk?.getConsent) {
    throw new Error("MetaKeep SDK is required");
  }
  if (
    !operationClient?.attachConsentResult ||
    (!operationClient?.reconcileAndFetchOperation &&
      !operationClient?.reconcileOperation)
  ) {
    throw new Error("operation client is incomplete");
  }

  store?.remember?.(safeOperationSnapshot(operation));
  let consentResult;
  try {
    consentResult = await sdk.getConsent(operation.consentToken);
  } catch (err) {
    return reconcileOperationUntilTerminal({
      operationClient,
      operationId: operation.operationId,
      store,
      poll,
      maxPolls,
      pollIntervalMs,
    });
  }
  const transactionId = extractMetaKeepTransactionId(consentResult);
  if (!transactionId) {
    return reconcileOperationUntilTerminal({
      operationClient,
      operationId: operation.operationId,
      store,
      poll,
      maxPolls,
      pollIntervalMs,
    });
  }
  const submitted = await operationClient.attachConsentResult(operation.operationId, {
    transactionId,
  });
  store?.update?.(safeOperationSnapshot(submitted));
  return reconcileOperationUntilTerminal({
    operationClient,
    operationId: operation.operationId,
    store,
    poll,
    maxPolls,
    pollIntervalMs,
  });
};
